import { DialogService } from 'aurelia-dialog';
import { Container } from 'aurelia-framework';
import { UniversalEntitySelect } from '../../../../../../dialog/universal-entity-select';
import {
    BS_IMAGE_CAPTION_TYPE,
    BS_IMAGE_FIGURE_TYPE,
    BS_IMAGE_IMG_TYPE,
    extractMediaDescription,
} from '../../../bootstrap-components/components/imageCaption';

export const resolveMediaSrc = (item) => {
    if (item?.file?.previewUrl) {
        return item.file.previewUrl.replace('$width', '1500').replace('$height', '-');
    }
    return item?.file?.downloadUrl || '';
};

const buildSlideFromMediaItem = (item, classSlide) => {
    const src = resolveMediaSrc(item);
    if (!src) return null;

    const description = extractMediaDescription(item);
    const figureComponents = [
        {
            type: BS_IMAGE_IMG_TYPE,
            attributes: {
                src,
                alt: item?.alt ?? '',
                title: item?.title ?? '',
            },
        },
    ];

    if (description) {
        figureComponents.push({
            type: BS_IMAGE_CAPTION_TYPE,
            content: description,
        });
    }

    return {
        tagName: 'div',
        classes: [classSlide],
        components: [
            {
                type: BS_IMAGE_FIGURE_TYPE,
                components: figureComponents,
            },
        ],
    };
};

export const openBulkImageSelect = ({ slidesCollection, config = {} } = {}) =>
    new Promise((resolve) => {
        if (!slidesCollection) {
            resolve([]);
            return;
        }

        const dialogService = Container.instance.get(DialogService);

        dialogService
            .open({
                viewModel: UniversalEntitySelect,
                model: {
                    selectModelId: 'media-database/media-item',
                    conditions: { type: { $in: ['image'] } },
                },
            })
            .whenClosed((data) => {
                const items = data.output;

                if (!items || items.length === 0) {
                    resolve([]);
                    return;
                }

                // Remove empty placeholder slides
                const children = [...slidesCollection.models];
                children.forEach((child) => {
                    if (!child) return;
                    const isEmptyDiv =
                        child.get('tagName') === 'div' &&
                        !child.components().length &&
                        !child.get('content')?.trim();
                    if (isEmptyDiv) {
                        child.remove();
                    }
                });

                const classSlide = config.classSlide || 'swiper-slide';

                items.forEach((item) => {
                    const slide = buildSlideFromMediaItem(item, classSlide);
                    if (slide) {
                        slidesCollection.add(slide);
                    }
                });

                resolve(items);
            });
    });

export default openBulkImageSelect;
